import React from 'react';
import { motion } from 'framer-motion';
import { CHECKOUT_URL, CTA_TEXT } from '../data/content';
type CtaButtonProps = {
  className?: string;
  note?: string;
};
export function CtaButton({
  className = '',
  note
}: CtaButtonProps) {
  return <div className={`flex w-full flex-col items-center ${className}`} data-id="element-14" data-mp="hl6vbv8r4cc8">
      <motion.a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" whileHover={{
      y: -2
    }} whileTap={{
      y: 0,
      scale: 0.99
    }} transition={{
      type: 'spring',
      stiffness: 400,
      damping: 24
    }} className="block w-full max-w-xl rounded-full bg-clay px-5 py-4 text-center font-sans text-[13px] font-semibold uppercase leading-snug tracking-[0.04em] text-cream shadow-soft transition-colors hover:bg-[#9c5430] focus:outline-none focus-visible:ring-4 focus-visible:ring-clay/30 sm:px-6 sm:py-5 sm:text-base sm:tracking-[0.08em]" data-id="element-15" data-mp="cjr93zuu7zs9">
        {CTA_TEXT}
      </motion.a>
      {note ? <p className="mt-3 text-center font-sans text-[10px] uppercase tracking-[0.14em] text-ink/50 sm:text-xs sm:tracking-[0.18em]" data-id="element-16" data-mp="157n4904rdjmx">
          {note}
        </p> : null}
    </div>;
}